var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtensions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#666666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "10,8 10,14 14.7,16.9 15.5,15.7 11.5,13.3 11.5,8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,12c0,0.3,0.1,0.7,0.1,1c0,3.9-3.1,7-7,7s-7-3.1-7-7s3.1-7,7-7c0.7,0,1.4,0.1,2,0.3V4.2 C12.4,4.1,11.7,4,11,4c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-0.3,0-0.7-0.1-1H17.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20,5 20,2 18,2 18,5 15,5 15,7 18,7 18,10 20,10 20,7 23,7 23,5  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensions);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO30KCS5zdDF7ZmlsbDojNjY2NjY2O30KPC9zdHlsZT4KPGc+Cgk8cmVjdCBjbGFzcz0ic3QwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KPC9nPgo8Zz4KCTxnPgoJCTxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iMTAsOCAxMCwxNCAxNC43LDE2LjkgMTUuNSwxNS43IDExLjUsMTMuMyAxMS41LDggCQkiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTcuOSwxMmMwLDAuMywwLjEsMC43LDAuMSwxYzAsMy45LTMuMSw3LTcsN3MtNy0zLjEtNy03czMuMS03LDctN2MwLjcsMCwxLjQsMC4xLDIsMC4zVjQuMgoJCQlDMTIuNCw0LjEsMTEuNyw0LDExLDRjLTUsMC05LDQtOSw5czQsOSw5LDlzOS00LDktOWMwLTAuMywwLTAuNy0wLjEtMUgxNy45eiIvPgoJCTxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iMjAsNSAyMCwyIDE4LDIgMTgsNSAxNSw1IDE1LDcgMTgsNyAxOCwxMCAyMCwxMCAyMCw3IDIzLDcgMjMsNSAJCSIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };